/*eslint-disable*/

import React from "react";
import { ChangeEvent } from "react";
import { HiCheckCircle, HiXCircle } from "react-icons/hi2";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

interface TimeEntryProps {
    label: string;
    value: number | null;
    onChange: (value: number | null) => void; // Accept number | null instead of event
    disabled: boolean; // New prop to handle disabling the input field
}

const TimeEntry: React.FC<TimeEntryProps> = ({
    label,
    value,
    onChange,
    disabled,
}) => {
    return (
        <div className="flex items-center gap-2 justify-start w-full">
            <span className="w-1/3 text-left font-bold">{label}:</span>
            <TextField
                type="number"
                value={value !== null ? value : ""} // Ensure null is represented as an empty string
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    const inputValue = e.target.value;
                    onChange(inputValue === "" ? null : parseFloat(inputValue)); // Convert empty string to null
                }}
                disabled={disabled}
                fullWidth
                sx={{
                    width: "66%",
                    "& .MuiInputBase-root": { padding: "2px" },
                    "& .MuiOutlinedInput-input": { padding: "4px 6px" },
                }}
                variant="outlined"
                // slotProps={{
                //     input: {
                //       className: disabled ? "bg-gray-200 cursor-not-allowed" : "",
                //     },
                //     htmlInput: {
                //       inputMode: "numeric",
                //     },
                //   }}
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position="start">km</InputAdornment>
                        ),
                        className: disabled
                            ? "bg-gray-200 cursor-not-allowed"
                            : "",
                    },
                    htmlInput: {
                        inputMode: "numeric",
                    },
                }}
            />
            {/* Display the warning icon only when value is empty and not disabled */}
            {!value && !disabled && (
                <HiXCircle className="text-rose-500" size={18} />
            )}
            {value && !disabled && (
                <HiCheckCircle className="text-gold" size={18} />
            )}
        </div>
    );
};

export default TimeEntry;
